import type {
  Profile,
  ProfileApiResponse,
  ProfileInfoApiResponse,
  StoreProfileApiPayload,
} from '@/features/Profile';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class ProfileHttpService extends HttpService {
  loadProfiles(): HttpClientResponse<ProfileApiResponse> {
    return this.httpClient.get('profiles');
  }

  loadProfile(id: number): HttpClientResponse<ProfileInfoApiResponse> {
    return this.httpClient.get(`profiles/${id}`);
  }

  storeProfile(
    data: StoreProfileApiPayload,
  ): HttpClientResponse<ProfileInfoApiResponse> {
    return this.httpClient.post('profiles', {
      data,
    });
  }

  updateProfile(data: Profile): HttpClientResponse<unknown> {
    return this.httpClient.put(`profiles/${data.id}`, { data });
  }

  deleteProfile(id: number): HttpClientResponse<unknown> {
    return this.httpClient.delete(`profiles/${id}`);
  }
}
